import { PseudoSection } from 'components/main/section-router/pseudo-section';
import { t } from 'i18next';

export const NotFound = () => (
  <PseudoSection
    header={t('main.not-found')}
    content={
      <p>Please check the URL or your access permissions and try again.</p>
    }
  />
);
